"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBemloEmail = void 0;
const isBemloEmail = (email) => !!email.match(/@bemlo\.(se|no|com|co\.uk)$/);
exports.isBemloEmail = isBemloEmail;
